import { ColumnsType, TableProps } from "antd/es/table";
import { Button, Modal, Tag } from "antd";
import React from "react";
import { DealRedeemItem } from "../../../api/admin/webshop/dealRedeems/DealRedeemItem";
import dayjs, { Dayjs } from "dayjs";

export const getDealRedeemDetails = (
  onViewDetails: (record: DealRedeemItem) => void,
): TableProps<DealRedeemItem>["columns"] => [
  {
    title: "Promo Code",
    dataIndex: "promoCode",
    key: "promoCode",
  },
  {
    title: "order Number",
    dataIndex: "orderId",
    key: "orderId",
  },
  {
    title: "total order value",
    dataIndex: "cartTotal",
    key: "cartTotal",
  },
  {
    title: "Discount Amount",
    dataIndex: "discountAmount",
    key: "discountAmount",
  },
  {
    title: "Name",
    key: "name",
    render: (_, record: any) => record.name || record.fullName,
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },

  {
    title: "Redeemed At",
    dataIndex: "createdAt",
    key: "createdAt",
    render: (createdAt: string) =>
      dayjs(createdAt).format("DD-MMM-YYYY HH:mm:ss"),
  },

  {
    title: "Actions",
    key: "actions",
    render: (text, record) => (
      <>
        <Button
          type="primary"
          onClick={() => {
            onViewDetails(record);
          }}
        >
          View Details
        </Button>
      </>
    ),
  },
];
